export default {
    title: 'Select trends',
    subtitle: 'Select the macro trends to evaluate'
}
